import { useEffect } from "react";
import { useMap } from "react-leaflet";
import "leaflet/dist/leaflet.css";

import L from "leaflet";
import "leaflet.heat";

/**
 * react-leaflet v3 compatible heatmap layer based in leaflet.heat library
 *
 * Ref: https://stackoverflow.com/questions/63640081/is-there-a-way-to-use-leaflet-heat-in-react
 *
 * @param {*} props Component properties
 * @returns
 */
export default function LLHeatLayer(props) {
  // Get Map
  const _map = useMap();

  const _points = props.points || [];
  const _options = props.options || {};

  // original code for heatmap
  useEffect(() => {
    const hmRef = L.heatLayer(_points, _options);
    hmRef.addTo(_map);

    return () => {
      _map.removeLayer(hmRef);
    };
  }, []);

  // TODO :: logic based on zoom level options settings
  // useEffect(() => {
  //   const hmRef = L.heatLayer(_points, _options).addTo(_map);

  //   // update options dynamically on zoom
  //   function handleZoom() {
  //     const zoom = _map.getZoom();
  //     console.log("zoom", zoom);

  //     if (zoom > 17) {
  //       hmRef.setOptions({
  //         radius: 40, // smaller spots
  //         blur: 50,
  //       });
  //     } else if (zoom > 15) {
  //       hmRef.setOptions({
  //         radius: 40, // smaller spots
  //         blur: 40,
  //       });
  //     } else {
  //       // reset to original options
  //       hmRef.setOptions(_options);
  //     }
  //   }

  //   _map.on("zoomend", handleZoom);

  //   return () => {
  //     _map.removeLayer(hmRef);
  //     _map.off("zoomend", handleZoom);
  //   };
  // }, []);

  return null;
}
